import * as PersistentStorage from '@shared/utils/persistent.storage'

const StoriesStorage = {
  storageKey: 'axoft_stories',
  storage: PersistentStorage,
  viewedFlagMap: {},

  setup(stories) {
    const storageStories = this.storage.getItem(this.storageKey, {})

    this.viewedFlagMap = this.mergeStoryViewFlags(stories, storageStories)
    this.saveToStorage()
  },

  mergeStoryViewFlags(stories, storageStories) {
    if (!stories?.length) return {}

    const merged = {}

    for (const story of stories) {
      merged[story.id] = {
        viewed: true,
        slides: {},
      }

      if (!story.slides?.length) continue

      story.slides.forEach((slide, i) => {
        merged[story.id].slides[i] = {
          viewed: !!storageStories?.[story.id]?.slides?.[i]?.viewed,
        }

        if (merged[story.id].viewed && !merged[story.id].slides[i].viewed) merged[story.id].viewed = false
      })
    }

    return merged
  },

  setViewedSlide(storyId, slideIdx) {
    try {
      this.viewedFlagMap[storyId].slides[slideIdx].viewed = true
      if (this.allSlidesFromStoryViewed(storyId)) this.setViewedStory(storyId)
      this.saveToStorage()
    } catch (e) {
      console.error('Error setViewedSlide', this.viewedFlagMap, `storyId = ${storyId}, slideIdx = ${slideIdx}`)
    }
  },

  setViewedStory(id) {
    this.viewedFlagMap[id].viewed = true
  },

  allSlidesFromStoryViewed(storyId) {
    const slidesMap = this.viewedFlagMap[storyId].slides

    for (const slideIdx in slidesMap) {
      if (!slidesMap[slideIdx].viewed) return false
    }

    return true
  },

  saveToStorage() {
    this.storage.setItem(this.storageKey, this.viewedFlagMap)
  },
}

export default StoriesStorage



// WEBPACK FOOTER //
// ./src/templates/components/base/stories/stories.storage.js